import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SavedCartsStore } from 'cart-data';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SavedCartSearchItem } from '@idealsupply/ngclient-webservice-shopping-cart';
import { ConfirmDialogResponse, DialogService, NoteComponent, LoadingSkeletonDirective2 } from 'common-ui';
import { ErrorComponent } from 'error-ui';

@Component({
  selector: 'ideal-saved-cart-list',
  imports: [
    MatListModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    NoteComponent,
    ErrorComponent,
    JsonPipe,
    LoadingSkeletonDirective2,
  ],
  templateUrl: './saved-cart-list.component.html',
  styleUrl: './saved-cart-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SavedCartsStore],
})
export class SavedCartListComponent {
  private readonly _dialogService = inject(DialogService);
  private readonly savedCartsStore = inject(SavedCartsStore);

  protected readonly savedCarts = this.savedCartsStore.savedCarts;
  protected readonly savedCartsLoading = this.savedCartsStore.savedCartsLoading;
  protected readonly savedCartsError = this.savedCartsStore.savedCartsError;

  protected async deleteCart(cart: SavedCartSearchItem) {
    const result = await this._dialogService.confirm(`Are you sure you want to delete the saved cart "${cart.name}"?`, 'Delete Cart', {
      negativeButtonHidden: true,
      positiveButtonLabel: 'Delete',
      positiveButtonWarn: true,
    });
    if (result === ConfirmDialogResponse.Positive) {
      await this.savedCartsStore.deleteSavedCart(cart.id);
    }
  }
}
